import img1 from "../../images/mens-fashion.jpeg";

export const categoriesData = [
  {
    name: "Brands",
    img: "https://www.gannett-cdn.com/media/2019/08/23/USATODAY/usatsports/gettyimages-881096270.jpg?crop=1365,768,x0,y0&width=1365&height=768&format=pjpg&auto=webp",
    path: "/explore",
    cName: "brands",
    c1Name: "category",
  },
  {
    name: "Fashion Shows",
    img: img1,
    path: "/explore",
    cName: "fashionShows",
    c1Name: "category",
  },
  {
    name: "Fashion Courses",
    img: "https://www.iiad.edu.in/wp-content/uploads/2021/12/programme-detail-desktop.webp",
    path: "/explore",
    cName: "fashionCourse",
    c1Name: "category",
  },
  {
    name: "Fashion Vlogs",
    img: "https://www.thefashionisto.com/wp-content/uploads/2021/01/Male-Fashion-Vlogger-800x533.jpg",
    path: "/explore",
    cName: "fashionVlogs",
    c1Name: "category",
  },
];
